import { getSuccessResponse } from "../../../../utils/reducerOperations";
import { fetchFormConfigurations } from "../../../inputFormConfigurations";
export function inviteUserSuccess(state, payload) {
  return {
    inviteUserApi: getSuccessResponse(payload),
    inputBoxConfiguration: fetchFormConfigurations(["email"]),
  };
}
